import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.CREATE_MEMBERSHIP_REQUEST,
    SUCCESS: types.CREATE_MEMBERSHIP_SUCCESS,
    FAILURE: types.CREATE_MEMBERSHIP_FAILURE,
    CANCEL: types.CREATE_MEMBERSHIP_CANCEL,
};

export default ReduxUtils.basicApiReducer({
    actionTypes,
});
